import React from "react";
import { Card, KeyValueList, ValueOrPlaceholder } from "@sscs/ui";
import { CweChip } from "../../../ui";
import styles from "./bugInfo.module.scss";
const CommonBugInfo = ({ bugDetails, sources, }) => {
    // API sometimes returns [""] when no researchers
    const researchers = bugDetails.researchers.filter((researcher) => Boolean(researcher));
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { details: [
                React.createElement("span", { key: "vuln-data" },
                    "Vulnerability data from: ",
                    React.createElement("b", null, sources.join(", "))),
            ] }, "Impact"),
        React.createElement(Card.Content, null, React.createElement(KeyValueList, { className: styles["bug-info"], list: {
                Description: bugDetails.description,
                Researchers: researchers.length > 0 ? (researchers.join(", ")) : (React.createElement(ValueOrPlaceholder, { value: undefined })),
                CWE: bugDetails.cwe.length > 0 ? (bugDetails.cwe.map((cwe) => (React.createElement(CweChip, { key: cwe.cwe_id, cwe: cwe })))) : (React.createElement(ValueOrPlaceholder, { value: undefined })),
            } }))));
};
export default CommonBugInfo;
//# sourceMappingURL=CommonBugInfo.js.map